import { render, staticRenderFns } from "./passwordReset.vue?vue&type=template&id=320eec07&scoped=true"
import script from "./passwordReset.vue?vue&type=script&lang=js"
export * from "./passwordReset.vue?vue&type=script&lang=js"
import style0 from "./passwordReset.vue?vue&type=style&index=0&id=320eec07&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320eec07",
  null
  
)

export default component.exports